import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { type ReactNode } from 'react';
import styled from 'styled-components';

const NodeRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  justify-content: space-between;
`;

const NodeLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export interface IDraggableTreeNodeTitleProps {
  icon?: ReactNode;
  title: string;
  onEdit?: () => void;
  onDelete?: () => void;
  extraActions?: ReactNode;
}

export function DraggableTreeNodeTitle({
  icon,
  title,
  onEdit,
  onDelete,
  extraActions,
}: IDraggableTreeNodeTitleProps) {
  return (
    <NodeRow>
      <NodeLabel>
        {icon}
        {title}
      </NodeLabel>
      {(onEdit || onDelete || extraActions) && (
        <span>
          {extraActions}
          {onEdit && (
            <Tooltip title="Modifica">
              <Button
                size="small"
                type="text"
                icon={<EditOutlined />}
                aria-label="Modifica"
                onClick={event => {
                  event.stopPropagation();
                  onEdit();
                }}
              />
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip title="Elimina">
              <Button
                size="small"
                type="text"
                danger
                icon={<DeleteOutlined />}
                aria-label="Elimina"
                onClick={event => {
                  event.stopPropagation();
                  onDelete();
                }}
              />
            </Tooltip>
          )}
        </span>
      )}
    </NodeRow>
  );
}
